<form
	[ngClass]="{'mt-5': addSpaceToPrevious}"
	[formGroup]="formGroup"
>

	<div
		class="row mb-3 formElementWrapper"
		[ngClass]="baseCssClass"
		(mouseout)="setHovered( false )"
		(mouseover)="setHovered( true )"
	>

		<!-- Label -->
		<ng-container *ngIf="!config.hideLabel">
				<app-label
					formEntityId="{{formEntityIdOverwrite ? formEntityIdOverwrite : formEntityId}}"
					labelText="{{ labelText ? labelText : getI18nString(false, translationPath + '.label') }}"
					[formControlInline]="formControlInline"
					[labelClassObject]="{
						'hovered': isHovered,
						'focused': hasFocus,
						'error': control?.errors && !hideErrors
					}"
					[labelHostClassString]="labelHostClassString"
					[labelInfoInline]="labelInfoInline"
					[required]="isRequired"
					[requiredByElster]="config.elsterRequiredField"
					[showElsterIndicator]="config.elsterShowIndicator"
				></app-label>
			</ng-container>

		<!-- Input Block -->
		<div
			class="inputBlockWrapper col-12"
			[ngClass]="{'col-md-8' : formControlInline}"
		>

			<div class="col-{{colSpan}} px-0">
				<!-- Input Wrapper -->
				<div
					class="inputWrapper mb-1 {{ formEntityIdOverwrite ? formEntityIdOverwrite + 'CalendarPopupTarget' : formEntityId + 'CalendarPopupTarget' }}"
					[ngClass]="{
						'controlDisabled': disableControl,
						'hovered': isHovered,
						'focused': hasFocus,
						'error': control?.errors && !hideErrors
					}"
				>

					<!-- Input Group -->
					<div class="row gx-0 px-2">

						<!-- DayPicker -->
						<ng-container *ngIf="calendarMode === calendarModeEnum.DAY">
							<span class="col ps-0 pe-2">
								<input
									#datepicker="ngbDatepicker"
									class="form-control"
									id="{{formEntityIdOverwrite ? formEntityIdOverwrite : formEntityId}}"
									formControlName="{{formControlNameOverwrite ? formControlNameOverwrite : formEntityId}}"
									placeholder="{{ config.hidePlaceholder ? null : getI18nString(false,translationPath + '.placeholder') }}"
									tabindex="{{config.tabindex}}"
									type="text"
									value="{{ controlValue | dateLocaleFormat: dateInputFormat : null }}"
									[attr.data-e2e]="formEntityId + '-input'"
									[readOnly]="readOnly"
									[appDisableControl]="{condition: disableControl, control: control}"
									ngbDatepicker
									[maxDate]="maxDate"
									[minDate]="minDate"
									[placement]="datepickerPopupPlacement"
									[positionTarget]="formEntityIdOverwrite ? '.' + formEntityIdOverwrite + 'CalendarPopupTarget' : '.' + formEntityId + 'CalendarPopupTarget'"
									(click)="setDate(datepicker)"
									(focusin)="setFocus( true )"
									(focusout)="setFocus( false )"
								>
							</span>

							<!-- Actions -->
							<ng-container
								[ngTemplateOutlet]="actionsTpl"
								[ngTemplateOutletContext]="{
									'datepicker': datepicker,
									'calendarMode': calendarModeEnum.DAY
								}"
							></ng-container>
						</ng-container>

						<!-- MonthPicker -->
						<ng-container *ngIf="calendarMode === calendarModeEnum.MONTH">
							<input
								class="col form-control"
								id="{{formEntityIdOverwrite ? formEntityIdOverwrite : formEntityId}}"
								formControlName="{{formControlNameOverwrite ? formControlNameOverwrite : formEntityId}}"
								placeholder="{{ config.hidePlaceholder ? null : getI18nString(false,translationPath + '.placeholder') }}"
								tabindex="{{config.tabindex}}"
								type="text"
								value="{{ controlValue | dateLocaleFormat: dateInputFormat : null }}"
								[appDisableControl]="{condition: disableControl, control: control}"
								[attr.data-e2e]="formEntityId + '-input'"
								[readOnly]="readOnly"
								(focusin)="setFocus( true )"
								(focusout)="setFocus( false )"
							>

							<!-- Actions -->
							<ng-container
								[ngTemplateOutlet]="actionsTpl"
								[ngTemplateOutletContext]="{
									'calendarMode': calendarModeEnum.MONTH
								}"
							></ng-container>
						</ng-container>
					</div>
				</div>

				<!-- Error -->
				<app-error
					[control]="control"
					[errorMsg]="errorMsg"
					[hideErrors]="hideErrors || hideErrorDescriptions"
				></app-error>
			</div>

			<!-- Input Information -->
			<app-info
				[baseClass]="'col-12 mb-3 mt-2 px-0'"
				[infoText]="getI18nString( false, translationPath + '.info' )"
				[hideInfoIcon]="true"
			></app-info>
		</div>
	</div>
</form>

<!-- ######################### TEMPLATES ######################### -->
<!-- Actions -->
<ng-template
	#actionsTpl
	let-datepicker="datepicker"
	let-calendarMode="calendarMode"
>
	<div
		class="d-flex col-auto input-actions"
		[ngClass]="{'disabled': disableControl}"
	>

		<!-- Clear -->
		<div *ngIf="showClearButton">
			<i
				class="input-group-text ft-x"
				(click)="clearControlValue()"
			></i>
		</div>

		<!-- Revert -->
		<div *ngIf="showRevertButton">
			<i
				class="input-group-text icon-action-undo"
				(click)="revertControlValue()"
			></i>
		</div>

		<!-- Calendar Icon -->
		<div
			*ngIf="calendarMode !== calendarModeEnum.MONTH && datepicker"
			class="cursor-pointer"
			(click)="setDate(datepicker)"
		>
			<i class="input-group-text icon-calendar"></i>
		</div>

		<!-- Calendar MonthPicker -->
		<div
			*ngIf="calendarMode === calendarModeEnum.MONTH"
			class="pt-1 align-self-center"
		>
			<app-month-picker
				#monthPicker
				[minDate]="monthPickerMinDate"
				[selectedDate]="controlValue"
				[preselectedDateList]="preselectedDateList"
				(selectedMonthDateEmitter)="setSelectedDate($event)"
			></app-month-picker>
		</div>
	</div>
</ng-template>
